// extracted by mini-css-extract-plugin
export var chip = "_az-0";
export var filterDropdown = "_az-5";
export var filterItem = "_az-6";
export var icon = "_az-1";
export var removeButton = "_az-3";
export var removeIcon = "_az-4";
export var separator = "_az-2";